// This file added by Bearer Web Developer - Schedule as a Future Order
import React from 'react';
import { observer } from "mobx-react-lite";
import styles from './scheduleCompact.module.scss';
import { useAppState } from '../../../../states/app-state';
import { TimeSensitiveEnum } from '../../../../states/scheduleOrderstate';

const ScheduleCompact: React.FC = observer(() => {
    const appstate = useAppState();
    const scheduleOrder = appstate?.selectedOrder?.scheduleOrder;
    const isDisabled = scheduleOrder?.isDisabled;
    const pastDue = (
        scheduleOrder?.timeSensitive === TimeSensitiveEnum.PastDue ||
        scheduleOrder?.timeSensitive === TimeSensitiveEnum.DueTodayPastTime
    ) && !scheduleOrder?.editing && !isDisabled;
    return (
        <section className={`${styles.schedule_compact} ${pastDue ? styles.schedule_compact_past_due : ''}`}>
            <h4>Earliest Pickup:</h4>
            <p>
                {scheduleOrder?.earliestDate}
                <hr />
                {scheduleOrder?.earliestTime}
            </p>
            <h4>Latest Pickup:</h4>
            <p>
                {scheduleOrder?.latestDate}
                <hr />
                {scheduleOrder?.latestTime}
            </p>
        </section>
    )
})
export default ScheduleCompact;